import React from 'react';
import SearchIcon from '../icons/SearchIcon';

interface ISearchProps {
  search: string | undefined;
  setSearch: (s: string) => void;
  clearSearch: (slug: string) => void;
  slug: string;
  placeholder?: string;
}

// Compact per-column text filter used in the table header.
const SearchField: React.FC<ISearchProps> = ({
  search,
  setSearch,
  clearSearch,
  slug,
  placeholder = 'Search',
}) => {
  return (
    // Its own <form>: Chrome only treats fields as an address (and offers saved addresses
    // and emails) in forms of three or more text fields, and it groups loose fields together.
    <form
      className={`filter-input ${search ? 'is-set' : ''}`}
      onSubmit={(e) => e.preventDefault()}
      autoComplete="off"
    >
      <SearchIcon width="14" height="14" />
      <input
        type="text"
        autoComplete="off"
        placeholder={placeholder}
        aria-label={placeholder}
        value={search || ''}
        onChange={(e) => setSearch(e.target.value)}
      />
      {search ? (
        <button
          type="button"
          className="filter-clear"
          aria-label={`Clear ${placeholder}`}
          onClick={() => clearSearch(slug)}
        >
          ×
        </button>
      ) : null}
    </form>
  );
};
export default SearchField;
